<template>
  <div>
    <div class="page-header">
      Branch Profile
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-lg-6 col-md-6">
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label">
                Company Name <span class="text-danger">*</span></label
              >
              <div class="col-md-7">
                <select
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('company_id') }"
                  v-model.number="model.company_id"
                >
                  <option value="">--select--</option>
                  <option v-for="(company, id) in companies" :key="id" :value="id">
                    {{ company }}
                  </option>
                </select>
                <div class="invalid-feedback" v-if="errors.has('company_id')">
                  {{ errors.first('company_id') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label"> Branch Name KH</label>
              <div class="col-md-7">
                <input
                  v-model="model.branch_name_kh"
                  type="text"
                  class="form-control kh-font"
                  :class="{ 'is-invalid': errors.has('branch_name_kh') }"
                  placeholder="Branch name KH"
                />
                <div class="invalid-feedback" v-if="errors.has('branch_name_kh')">
                  {{ errors.first('branch_name_kh') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label">
                Branch Name En <span class="text-danger">*</span></label
              >
              <div class="col-md-7">
                <input
                  v-model="model.branch_name_en"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('branch_name_en') }"
                  placeholder="Branch name En"
                />
                <div class="invalid-feedback" v-if="errors.has('branch_name_en')">
                  {{ errors.first('branch_name_en') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label"> Branch Code</label>
              <div class="col-md-7">
                <input
                  v-model="model.branch_code"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('branch_code') }"
                  placeholder="Branch code"
                />
                <div class="invalid-feedback" v-if="errors.has('branch_code')">
                  {{ errors.first('branch_code') }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-lg-6 col-md-6">
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-control-label control-label">Phone Number</label>
              <div class="col-md-7">
                <input
                  v-model="model.branch_phone"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('branch_phone') }"
                  placeholder="Enter phone number"
                />
                <div class="invalid-feedback" v-if="errors.has('branch_phone')">
                  {{ errors.first('branch_phone') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-control-label control-label">Email Address</label>
              <div class="col-md-7">
                <input
                  v-model="model.branch_email"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('branch_email') }"
                  placeholder="Enter email address"
                />
                <div class="invalid-feedback" v-if="errors.has('branch_email')">
                  {{ errors.first('branch_email') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-control-label control-label">Address</label>
              <div class="col-md-7">
                <textarea
                  v-model="model.branch_address"
                  rows="4"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('branch_address') }"
                  placeholder="Enter your address"
                ></textarea>
                <div class="invalid-feedback" v-if="errors.has('branch_address')">
                  {{ errors.first('branch_address') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="row  text-right">
          <div class="col-lg-12">
            <ts-button color="primary" :disabled="saving" :waiting="saving" @click="onSave">
              Save
            </ts-button>
            <ts-button class="ml-2" @click="$router.push({ name: 'branch' })">
              Cancel
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import apiBranchCompany from '@/api/administration/branch-company'

export default {
  name: 'branch-create',
  beforeRouteEnter: async (to, from, next) => {
    let response = await apiBranchCompany.get()
    to.params.companies = response
    next()
  },

  props: ['companies'],

  data() {
    return {
      model: {
        company_id: '',
        branch_name_kh: '',
        branch_name_en: '',
        branch_code: '',
        branch_address: '',
        branch_phone: '',
        branch_email: ''
      },
      saving: false,
      errors: new Errors()
    }
  },
  created() {},
  computed: {},
  methods: {
    onSave() {
      this.saving = true
      this.$store
        .dispatch('administration/branch/storeBranchProfile', Object.assign({}, this.model))
        .then(response => {
          this.saving = false
          this.clearForm()
          this.$toasted.success(response.message)
          this.$router.push({ name: 'branch' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.saving = false
        })
    },

    clearForm() {
      this.model.company_id = ''
      this.model.branch_name_kh = ''
      this.model.branch_name_en = ''
      this.model.branch_code = ''
      this.model.branch_address = ''
      this.model.branch_phone = ''
      this.model.branch_email = ''
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('branch/RESET_STATE')
    }
    next()
  }
}
</script>
